export default __webpack_public_path__ + "static/media/project_details.e5c9c37a.jpg";